export default __webpack_public_path__ + "static/media/pj-instagram.a0dcb507.png";